<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" />
      <!-- Main Navbar -->
      <main-navbar/>
      <d-col
        class="main-content mb-4 offset-lg-2 offset-md-3 p-0"
        tag="main"
        lg="10"
        md="9"
        sm="12">
        <!-- Content -->
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';
import MainSidebar from '@/components/layout/MainSidebar.vue';
import MainNavbar from '@/components/layout/MainNavbar';

export default {
  name: 'main-view',
  components: {
    MainNavbar,
    MainSidebar
  },
  data () {
    return {
      sidebarItems: getSidebarItems(),
    };
  },
};
</script>

<style lang="scss">
  .main-content {
    position: absolute;
    @media only screen and (max-width: 1380px) {
      margin-left: 220px;
    }
    @media only screen and (max-width: 1380px) {
      max-width: 82.333333%;
    }
    @media only screen and (max-width: 1200px) {
      max-width: 81.333333%;
    }
    @media only screen and (max-width: 1145px) {
      max-width: 80%;
    }
    @media only screen and (max-width: 1070px) {
      max-width: 79%;
    }
  }
</style>
